module.exports = "https://img1.huilianyi.com/d/ocr.daed41b13d.appcore.png";